import React from 'react';

const SelectApps = ({appList}) => {
    return appList.map((app) => {
        return (
            <div key={app.title} className="card">
                <header className="card-header">
                    <p className="card-header-title">
                    {app.title}
                    </p>
                </header>
                <div className="card-content">
                    <div className="content">
                    {app.description}
                    <br />
                    </div>
                </div>
                <footer className="card-footer">
                    <a href={app.link} className="card-footer-item">Go</a>
                </footer>
            </div>
        );
    });
}
 
export default SelectApps;